import * as yup from 'yup';
import { AnyObject, Maybe } from 'yup/lib/types';

function containsSpecialChars(str: any) {
  const specialChars = '[`!@#$%^&*()_+-=[]{};\':"\\|,.<>/?~]/';
  return specialChars
    .split('')
    .some((specialChar) => str.includes(specialChar));
}
function onenumber(str: any) {
  const specialChars = '1234567890';
  return specialChars
    .split('')
    .some((specialChar) => str.includes(specialChar));
}
function oneupper(str: any) {
  return str !== str.toLowerCase();
}
function onelower(str: any) {
  return str !== str.toUpperCase();
}

yup.addMethod<yup.StringSchema>(
  yup.string,
  'validatePasswordStrength',
  function () {
    return this.test((value, { createError }) => {
      if (!value || value.length === 0) {
        return createError({ message: 'Please enter your password.' });
      } else {
        if (value.length < 10) {
          return createError({ message: 'Password requires 10 characters.' });
        }
        if (!onenumber(value)) {
          return createError({ message: 'Password requires a number.' });
        }
        if (!oneupper(value)) {
          return createError({
            message: 'Password requires a uppercase letter.',
          });
        }
        if (!onelower(value)) {
          return createError({
            message: 'Password requires a lowercase letter.',
          });
        }
        if (!containsSpecialChars(value)) {
          return createError({
            message: 'Password requires at least one special character.',
          });
        }
      }
      return true;
    });
  }
);

// typescript types for custom yup methods
declare module 'yup' {
  interface StringSchema<
    TType extends Maybe<string> = string | undefined,
    TContext extends AnyObject = AnyObject,
    TOut extends TType = TType,
  > extends yup.BaseSchema<TType, TContext, TOut> {
    validatePasswordStrength(): StringSchema<TType, TContext>;
  }
}

export default yup;
